import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Grid, IconButton, Tooltip } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

import { useAuth } from "../common/context/clientContext";
import { axiosPost } from "../common/services/axios/apiCalls"
import SetLoading from "../common/components/modals/setLoadingModal";
import Footer from "../common/components/footer/footer";

import MenuBar from "../components/menuBar/menuBar";
import GroupsCard from "../components/card/groupsCard";

export default function SubCategory({ additionalParams }) {
    /** PARAMS */
    const { category, subcategory } = useParams();

    /** CONST */
    const navigate = useNavigate();
    const { user, token, setUser, setToken } = useAuth()
    const [loading, setLoading] = useState(true)
    const [categories, setCategories] = useState([])
    const [subcategoryInfo, setSubcategoryInfo] = useState({})
    const [productTypes, setProductTypes] = useState([])

    const getCatalogUsername = async () => {
        setLoading(true);

        const axiosData = {
            code: `${process.env.REACT_APP_COMPANY}`
        }

        try {
            const response = await axiosPost("/public/catalog/category/read", token, axiosData)
            return response.data
        } catch (error) {
            setLoading(false);
            navigate('/notfound?message=ApiError');
        }
    }

    const getSubcategoryInfo = async () => {
        const axiosData = {
            code: subcategory
        }

        try {
            const response = await axiosPost("/public/catalog/group/read", token, axiosData)
            return response.data
        } catch (error) {
        }
    }
    const loadProductTypes = async () => {
        try {
            const response = await axiosPost("/public/product/get/types", token)
            return response.data
        } catch (error) {
        }
    }

    /** FUNCTIONS */
    const navigateToCatalog = () => {
        navigate(`/catalog/${category}`);
    }

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);

            setCategories(await getCatalogUsername())
            setSubcategoryInfo(await getSubcategoryInfo())
            setProductTypes(await loadProductTypes())

            setLoading(false);
        };

        fetchData();
    }, [])

    return (
        <div className="d-flex flex-column min-vh-100">
            {loading && <SetLoading />}
            {!loading && categories && subcategoryInfo && productTypes &&
                <>
                    <div className="flex-grow-1">
                        <MenuBar menuItems={categories} />
                        <div className="container-xxl">
                            <Grid className='mt-4'>
                                <Tooltip title="Volver a subcategorías">
                                    <IconButton onClick={navigateToCatalog}>
                                        <ArrowBack fontSize="large" />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                            <Grid className={"info-panel"}>
                                <h2 className="catalog-title">{subcategoryInfo.subcategory.title}</h2>
                                <p>{subcategoryInfo.subcategory.info}</p>
                            </Grid>
                            {subcategory &&
                                <GroupsCard
                                    allowActions={additionalParams}
                                    subcategoryInfo={subcategoryInfo.subcategory}
                                    groupsData={subcategoryInfo.groups}
                                    productTypes={productTypes}
                                />
                            }
                        </div>
                    </div>
                    <Footer />
                </>
            }
        </div>
    );
}
